import { HeaderCtaCountProps } from '@/types/props/components/layout';

export default function HeaderCtaCount({ cta }: HeaderCtaCountProps) {
  if (cta === 0) return null;

  return (
    <span className="tw-text-white tw-font-semibold tw-text-xs tw-bg-main tw-rounded-full tw-px-2 tw-py-1">
      {cta}
    </span>
  );
}
